export default function isDOMElement(element) {
  return element !== null && element instanceof HTMLElement;
}
